import { gestifyLogin } from '../../api';
import { getGestifyTokenCookies } from '../../helpers/authCookies';
import { AuthParams } from '../../models';

/**
 * Effettua il login a Gestify con le credenziali fornite e restituisce il
 * token di accesso (necessario per le chiamate orchestrate lato backend).
 * Ritorna `undefined` se il login fallisce.
 */
export const gestifyAuthenticate = async ({
  username,
  password,
}: AuthParams): Promise<string | undefined> => {
  const loginResponse = await gestifyLogin({ username, password });
  if (!loginResponse || loginResponse.errors) return undefined;
  return (
    getGestifyTokenCookies().gestifyToken ??
    loginResponse.access_token ??
    undefined
  );
};
